import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PublicOfferPage } from '@/pages/offer-public/PublicOfferPage';
import { APP_LANGUAGES } from '@/stores/global.store';

// Public, unauthenticated route reached only from the token link in the offer email. It sits outside
// the `_authenticated` tree, following the `/book-meeting/$slug` public-form pattern.
const searchSchema = z.object({
	lang: z.enum(APP_LANGUAGES).optional(),
});

export const Route = createFileRoute('/offer/$token')({
	validateSearch: searchSchema,
	component: PublicOfferPage,
});
